export default function SubmitButton(props) {
    console.log(props.details);
    console.log(props.task);
    console.log(props.task.length);
        let news=props.task.map((a,index,arr)=>{
            return <li key={index}>{a}<button class="delete" onClick={()=>{
                props.setTask(props.task.filter((a,i)=>i !== index))
            }}>X</button></li>
        })
        return news
}
